import { createFileRoute } from '@tanstack/react-router';
import { requireSession } from '../../auth/require-session.js';
import { SessionError, SessionPending } from '../../auth/SessionStates.js';
import { parseChronicleSearch } from '../../chronicle/chronicle-model.js';
import { ChroniclePage } from '../../chronicle/chronicle-page.js';

/**
 * `/chronicle` (1.O-2 deliverable 3): the world's events in in-world order, `?density=era|year|month`,
 * guarded as `/doc/:id` is. With the `chrono` flag off the page says so and asks for nothing.
 */
export const Route = createFileRoute('/chronicle/')({
  staticData: { crumb: 'Chronicle' },
  beforeLoad: async ({ location }) => ({ me: await requireSession(location.pathname) }),
  pendingComponent: SessionPending,
  pendingMs: 0,
  pendingMinMs: 0,
  errorComponent: SessionError,
  validateSearch: parseChronicleSearch,
  component: ChroniclePage,
});
